const interiorHero = {
  displayField: 'internalName',
  name: 'Interior Hero',
  description: '',
  fields: [
    {
      id: 'internalName',
      name: 'Internal Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'location',
      name: 'Location',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'caption',
      name: 'Caption',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [ { size: { min: null, max: 256 } } ],
      disabled: false,
      omitted: false
    },
    {
      id: 'source',
      name: 'Source',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { in: [ 'Image Upload', 'Video Upload', 'Video Url' ] } ],
      defaultValue: { 'en-US': 'Image Upload' },
      disabled: false,
      omitted: false
    },
    {
      id: 'imgFocalPoint',
      name: 'Image (OR Video Poster Image)',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'imageWithFocalPoint' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'videoUpload',
      name: 'Video Upload',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'video' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'videoSrc',
      name: 'Video Url Source',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Image OR Video Poster Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false,
      linkType: 'Asset'
    }
  ],
  sys: {
    id: 'interiorHero',
    version: 45,
    updatedAt: '2023-08-02T22:05:25.692Z'
  }
};
export default interiorHero;